module.exports = __webpack_public_path__ + "static/img/no_data.d5b847fb.png";